import React from "react";

export default function FieldSelectField_FormValueNotEmpty(props:any) {




    const valueClasses = Classes("ui5-txt-default ui5-field-form-editable dropdown-form no-wrap h-36", props.className)


    const selectedField = props.field.fields.get(props.value)
    const iconClasses = Classes('ui5-ico-15 m-r-8', selectedField.icon)

    return (
        <React.Fragment>
            <div className={valueClasses} onClick={props.onClick}>
                <div className={iconClasses} />
                <span className="txt-truncate">{selectedField?.label}</span>
            </div>
            {props.children}
        </React.Fragment>
    );
}
